import { FC } from 'react';
import {
  BooleanField,
  BooleanInput,
  Datagrid,
  List,
  NumberField,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  SelectInput,
  TextField,
} from 'react-admin';

const updateChannelFilters = [
  <SearchInput key="searchInput" source="q" alwaysOn />,
  <ReferenceInput key="referenceInput" source="hardware_id" reference="hardware" alwaysOn>
    <SelectInput source="name" />
  </ReferenceInput>,
  <BooleanInput source="active" />,
];

export const UpdateChannelList: FC = () => {
  return (
    <List filters={updateChannelFilters} filterDefaultValues={{ hardware_id: 1 }}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="name" />
        <ReferenceField source="hardware_id" reference="hardware">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="hardware_revision_id" reference="hardware_revisions">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="software_release_id" reference="software_releases">
          <TextField source="name" />
        </ReferenceField>
        <BooleanField source="active" />
        <NumberField source="units_count" />
      </Datagrid>
    </List>
  );
};
